<template>
  <div class="container-fluid my-3 py-3">
    <div class="row mb-3">
      <div class="col-6">
        <div class="form-floating">
          <input
            id="description"
            type="email"
            name="username"
            class="form-control"
            @keyup.enter="submitForm"
            v-model="description"
            placeholder="name@examp"
            required
          />
          <label for="description" class="form-label">{{ $t('description') }}</label>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-6">
        <div class="form-floating">
          <input
            id="inputFirstname"
            type="text"
            name="first_name"
            class="form-control"
            @keyup.enter="submitForm"
            v-model="first_name"
            placeholder="name@examp"
            required
          />
          <label for="inputFirstname" class="form-label">{{ $t('first_name') }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="form-floating">
          <input
            id="inputLastname"
            type="text"
            name="last_name"
            class="form-control"
            @keyup.enter="submitForm"
            v-model="last_name"
            placeholder="name@examp"
            required
          />
          <label for="inputLastname" class="form-label">{{ $t('last_name') }}</label>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-6">
        <div class="form-floating">
          <input
            id="inpuEmail"
            type="email"
            name="username"
            class="form-control"
            @keyup.enter="submitForm"
            v-model="email"
            placeholder="name@examp"
            required
          />
          <label for="inputEmail" class="form-label">{{ $t('email') }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="form-floating">
          <input
            id="inputPhone"
            type="text"
            name="username"
            class="form-control"
            @keyup.enter="submitForm"
            v-model="phone_number"
            placeholder="name@examp"
            required
          />
          <label for="inputPhone" class="form-label">{{ $t('phone') }}</label>
        </div>
      </div>
    </div>

    <div class="row mb-3" v-if="isPushFeatureEnabled">
      <div class="col-12">
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="enablePush"
            v-model="enable_push"
          />
          <label class="form-check-label" for="enablePush">
            {{ $t('enable_push_notifications') }}
          </label>
        </div>
      </div>
    </div>
    <div class="text-danger" v-if="errors.length">
      <p v-for="error in errors" v-bind:key="error">{{ $t(error) }}</p>
    </div>
    <button class="btn btn-success mb-0 ms-auto" @click="submitForm">{{ $t('save') }}</button>
  </div>
</template>

<script>
import { createToast } from '@/assets/js/myToast.js';
import axios from 'axios';
export default {
  name: 'EditReportUser',
  props: {
    reportUser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      description: '',
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      enable_push: false,
      errors: [],
    };
  },
  computed: {
    isPushFeatureEnabled() {
      return this.$store.getters.isFeatureEnabled('push_notifications');
    },
  },
  mounted() {
    this.description = this.reportUser.description || '';
    this.first_name = this.reportUser.first_name || '';
    this.last_name = this.reportUser.last_name || '';
    this.email = this.reportUser.email || '';
    this.phone_number = this.reportUser.phone_number || '';
    this.enable_push = this.reportUser.enable_push || false;
  },
  methods: {
    submitForm() {
      this.errors = [];

      const patchData = {
        description: this.description,
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        phone_number: this.phone_number,
        enable_push: this.enable_push,
      };
      axios
        .patch(`/api/v1/report_users/${this.reportUser.id}/`, patchData)
        .then(() => {
          createToast({ text: this.$t('successEditReportUser'), type: 'success' });
          this.$emit('closeModal');
        })
        .catch((error) => {
          this.loading = false;
          if (error.response) {
            for (const property in error.response.data) {
              this.errors.push(`${error.response.data[property]}`);
            }
            console.error(JSON.stringify(error.response.data));
          } else if (error.message) {
            console.error(JSON.stringify(error.message));
          } else {
            console.error(JSON.stringify(error));
          }
        });
    },
  },
};
</script>
